import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';


@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class GordionTakim extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;

  product: ProductDefinition;

  seletedPine: string = GordionPine.Normal;
  seletedTable: string = GordionTable.Tekil;
  isWall: boolean = true;

  defHideObjects = [
    '_yyy',

  ];

  defShowObjects =  [
    'duvarlar_yyy',
    'zemin_yyy',
    'gordion_toplanti_masa',
    'gordion_sehpa',
    'gordion_masa',
    'gordion_tekil_masa_yyy',
    'gordion_dolap',
    'm4_yyy',
  ];

  availableAnimations: AnimationDefinition[] = [];
  private _nodeMap: NodeMap[] = null;

  async created() {
    this.product = Store.getProductById('gordion_takim');
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);

    this.availableAnimations =  [];
    this.availableAnimationsChanged();
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });
    await this._configuratorService.hideObjects({ objects: ['gordion_toplanti_masa_cam_fume','gordion_masa_cam_fume'], operator: FilterOperators.Contains });

    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color,element.palette,element.id);
      });
      await this.changePine(Store.state.selection.pine);
      await this.changeWall(Store.state.selection.wall);
      await this.changeTable(Store.state.selection.tabletype);

    } else {
      await  this.applyDefaultSelection();
    }

  }


  async changeWall(wall: boolean) {
    if (wall) {

      await this._configuratorService.showObjects({ objects: ['duvarlar_yyy'], operator: FilterOperators.Contains });

    } else {

      await this._configuratorService.hideObjects({ objects:  ['duvarlar_yyy'], operator: FilterOperators.Contains });
    }
    this.isWall = wall;
    Store.state.selection.wall = wall;
  }

  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }

  async applyDefaultSelection() {
    const selection = new BasicEtajerliMasaSelection();

    selection.parts = [];
    selection.pine = GordionPine.Normal;
    selection.wall = true;
    selection.tabletype = GordionTable.Tekil;

    //console.log(this.product.defaults.parts);

    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color,element.palette,element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.name = element.name;
      part.palette = element.palette;
      selection.parts.push(part);
    });
    Store.state.selection = selection;

  }

  async changePine(pine:GordionPine) {
    if (pine === GordionPine.Fume) {
      await this._configuratorService.hideObjects({ objects: ['gordion_toplanti_masa_cam_duz','gordion_masa_cam_duz'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['gordion_toplanti_masa_cam_fume','gordion_masa_cam_fume'], operator: FilterOperators.Contains });
      Store.state.selection.pine = GordionPine.Fume;
      this.seletedPine = GordionPine.Fume;
    }
    if (pine === GordionPine.Normal) {
      await this._configuratorService.hideObjects({ objects: ['gordion_toplanti_masa_cam_fume','gordion_masa_cam_fume'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['gordion_toplanti_masa_cam_duz','gordion_masa_cam_duz'], operator: FilterOperators.Contains });
      Store.state.selection.pine = GordionPine.Normal;
      this.seletedPine = GordionPine.Normal;
    }
  }
  async changeTable(table:GordionTable) {
    if (table === GordionTable.Tekil) {
      await this._configuratorService.hideObjects({ objects: ['gordion_etajer_yyy','gordion_kesonlu_masa_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['gordion_tekil_masa_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.tabletype = GordionTable.Tekil;
      this.seletedTable = GordionTable.Tekil;
    }
    if (table === GordionTable.Etajer) {
      await this._configuratorService.hideObjects({ objects: ['gordion_tekil_masa_yyy','gordion_kesonlu_masa_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['gordion_etajer_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.tabletype = GordionTable.Etajer;
      this.seletedTable = GordionTable.Etajer;
    }
    if (table === GordionTable.Keson) {
      await this._configuratorService.hideObjects({ objects: ['gordion_etajer_yyy','gordion_tekil_masa_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['gordion_kesonlu_masa_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.tabletype = GordionTable.Keson;
      this.seletedTable = GordionTable.Keson;
    }
  }
  async colorChanged(color: any,palette: any,part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}

export class BasicEtajerliMasaSelection {
  pine: GordionPine;
  parts: PartSelection[];
  wall: boolean;
  tabletype: GordionTable;
}

export class PartSelection {
  id: string;
  palette: string;
  name: string;
  color: string;

}
enum GordionPine {
  Fume = 'fume',
  Normal = 'normal',

}
enum GordionTable {
  Tekil = 'tekil',
  Etajer = 'etajer',
  Keson = 'keson',
}



// WEBPACK FOOTER //
// ./src/components/families/gordion/GordionTakim.ts